export const getLocalStorage = (key) => {
  const storageType = 'localStorage';
  const isBrowser = (() => typeof window !== 'undefined')();
  return isBrowser ? window[storageType][key] : '';
};

export const setLocalStorage = (key, value) => {
  const storageType = 'localStorage';
  const isBrowser = (() => typeof window !== 'undefined')();
  if (isBrowser) {
    window[storageType].setItem(key, value);
    return true;
  }
  return false;
};

export const removeLocalStorage = (key) => {
  const storageType = 'localStorage';
  window[storageType].removeItem(key);
};

export const emptyLocalStorage = (keepProfileAndTimezone = false) => {
  const storageType = 'localStorage';
  const keysToRemove = [];

  // Loop through localStorage keys
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < window[storageType].length; i++) {
    const key = window[storageType].key(i);

    // Add keys to remove unless they are 'LANGUAGE' or should be kept
    if (key !== 'LANGUAGE' && key !== 'oidc' && key !== 'signatureLog' && key !== 'todaysDate' && (!keepProfileAndTimezone || (key !== 'profile' && key !== 'timezone'))) {
      keysToRemove.push(key);
    }
  }

  // Remove the keys in the keysToRemove array
  keysToRemove.forEach((key) => {
    window[storageType].removeItem(key);
  });
};


export const emptySessionStorage = () => {
  const storageType = 'sessionStorage';
  window[storageType].clear();
};